import type { SVGProps } from "react";
export interface CalendarDaysIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CalendarDaysIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CalendarDaysIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21 6.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M19.875 6c0-.996-.778-1.81-1.76-1.87a1.124 1.124 0 0 1-2.233-.005H8.118a1.125 1.125 0 0 1-2.235.005A1.874 1.874 0 0 0 4.125 6v12c0 1.036.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zM16.5 16.628a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.245zm1 .743a.62.62 0 0 0 0-.743zm-4.888-.497a.6.6 0 0 0-.113-.247v.745a.6.6 0 0 0 .113-.246l.014-.126zm-1.111-.247a.62.62 0 0 0-.127.373l.014.126a.6.6 0 0 0 .113.246zm-3.888.247a.6.6 0 0 0-.113-.246v.743a.6.6 0 0 0 .113-.245L7.625 17zM6.5 16.628a.62.62 0 0 0 0 .743zm10-5a.62.62 0 0 0-.125.373l.012.126a.6.6 0 0 0 .113.243zm1 .742a.6.6 0 0 0 .112-.243l.013-.127-.013-.126a.6.6 0 0 0-.111-.246zm-4.888-.495a.6.6 0 0 0-.113-.248v.744a.6.6 0 0 0 .113-.245l.014-.125zm-1.111-.248a.62.62 0 0 0-.127.373l.014.127a.6.6 0 0 0 .113.244zm-3.888.247a.6.6 0 0 0-.113-.246v.742a.6.6 0 0 0 .113-.243L7.625 12zM6.5 11.628a.62.62 0 0 0-.125.373l.013.126c.019.09.059.171.112.243zM8.625 17a1.625 1.625 0 0 1-3.242.166L5.375 17l.008-.166A1.625 1.625 0 0 1 7 15.376l.166.007c.82.083 1.459.776 1.459 1.617m5 0a1.624 1.624 0 0 1-3.242.166L10.376 17l.007-.166A1.625 1.625 0 0 1 12 15.376l.165.007c.82.083 1.46.775 1.46 1.617m5 0A1.625 1.625 0 1 1 17 15.376l.166.007c.82.083 1.46.776 1.46 1.617Zm-10-5a1.625 1.625 0 0 1-3.242.166l-.008-.165.008-.167A1.626 1.626 0 0 1 7 10.373l.166.01c.82.082 1.459.775 1.459 1.617m5 0a1.625 1.625 0 0 1-3.242.166l-.007-.165.007-.167A1.626 1.626 0 0 1 12 10.373l.165.01c.82.082 1.46.775 1.46 1.617m5 0a1.626 1.626 0 0 1-3.241.166l-.009-.165.009-.167A1.625 1.625 0 0 1 17 10.373l.166.01c.82.083 1.46.775 1.46 1.617Zm3.5 6A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6a4.12 4.12 0 0 1 4.006-4.119 1.125 1.125 0 0 1 2.237-.006h7.764a1.125 1.125 0 0 1 2.235.006 4.12 4.12 0 0 1 4.008 4.12v12Z"
      />
    </svg>
  );
}
